import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { UsecaseBaseComponent } from 'src/app/usecase/usecase-base/usecase-base.component';

@Component({
  selector: 'app-uiform-base',
  templateUrl: './uiform-base.component.html',
  styleUrls: ['./uiform-base.component.scss'],
})
export class UiformBaseComponent extends UsecaseBaseComponent {
  @Input() uiformId: number | null = 0;
  public filterAttributes: any = [];

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute,
  ) {
    super(locator, route);
    let _self = this;
    if (route.snapshot.paramMap.get('uiformId'))
      _self.uiformId = Number(route.snapshot.paramMap.get('uiformId'));

    _self.locator.config
      .getProperty('endpoint.ui.forms')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }
  override ngOnInit() {
    let _self = this;
    _self.removeIt();
    if (_self.uiformId)
      this.get(_self.uiformId, async function () {
        _self.usecaseId = _self.form.data.userstoryId;
        await _self.getUsecaseSchema();
      });
  }

  override populateForm(form: any, data: any) {
    form.id = data.id;
    form.title = data.title;
    form.subtitle = data.subtitle;
    form.description = data.description;
    form.userstoryId = data.userstoryId;
    form.code = data.code;
    form.description = data.description;
    form.columns = data.columns;
    form.fields = data.fields;
    form.readOnly = data.readOnly;
    if (data.buttons) {
      form.buttons = data.buttons;
    }
  }

  // Method to get the button label based on the key
  getButtonLabel(buttonKey: string): string {
    const labels: { [key: string]: string } = {
      save: 'UIFORM.BUTTON.SAVE',
      cancel: 'UIFORM.BUTTON.CANCEL',
      delete: 'UIFORM.BUTTON.DELETE',
      list: 'UIFORM.BUTTON.LIST',
      new: 'UIFORM.BUTTON.NEW',
    };
    return labels[buttonKey] || buttonKey;
  }

  // Method to get the icon class based on the key
  getButtonIcon(btn: any): string {
    const icons: Record<string, string> = {
      save: 'fas fa-save',
      cancel: 'fas fa-times',
      delete: 'bx bxs-trash',
      list: 'fas fa-list',
      new: 'fa fa-plus',
      report: 'bi bi-clipboard2-data',
      form: 'bi bi-ui-checks',
      url: 'bi bi-link-45deg',
    };
    // detect correct key
    let key = btn?.type;

    if (!key) {
      key = this.detectLegacyType(btn);
    }

    if (key === 'system') {
      key = btn?.name?.toLowerCase();
    }

    return icons[key] || '';
  }

  public detectLegacyType(btn: any): string {
    const systemActions = ['save', 'cancel', 'list', 'delete', 'new'];

    if (btn.name && systemActions.includes(btn.name.toLowerCase())) {
      return 'system';
    }

    if (btn.url) {
      return btn.url.startsWith('http') ? 'url' : 'form';
    }

    return 'unknown';
  }

  get filteredFields() {
    return this.form.data['fields'].filter((f: { id: number }) => {
      const attr = this.getAttributeByIds(f.id);
      return (
        attr &&
        attr.disable != 1 &&
        attr.type !== 'doc' &&
        attr.type !== 'map' &&
        attr.type !== 'location'
      );
    });
  }

  getAttributeListById(fieldId: number) {
    return this.usecaseAttributes.find(
      (attr: any) =>
        attr.id === fieldId &&
        attr.system != 1 &&
        attr.listView != 1 &&
        attr.disable != 1,
    );
  }

  getAttributeById(fieldId: number) {
    return this.usecaseAttributes.find(
      (attr: any) =>
        attr.id === fieldId && attr.system != 1 && attr.disable != 1,
    );
  }

  /**
   * Delete a record
   *
   * @param id
   * @returns
   */
  public deleteUseCaseData(id: number | null, callback?: any) {
    let _self = this;

    if (!id || !(id > 0)) return;

    let flag = confirm('Are you sure');
    if (!flag) {
      return;
    }
    let url = _self.apiurl + '/delete/' + id;
    this.locator.http.get(url, function (res: any, error: boolean) {
      if (error) {
        alert('Server Error:' + error);
        return;
      }
      _self.form.error = !res.success;
      _self.form.message = res.message;
      _self.form['inputerror'] = res.result['inputerror'];
      if (res.success) {
        callback();
      }
    });
  }
  public async deleteUseSelectedUseCase(data: any[], callback?: any) {
    if (!data || data.length === 0) return;

    const confirmed = confirm(
      'Are you sure you want to delete selected records?',
    );
    if (!confirmed) return;

    const successfullyDeletedIds: any[] = [];
    let completedRequests = 0;

    data.forEach((element: any) => {
      const url = this.apiurl + '/delete/' + element.id;

      this.locator.http.get(url, (res: any, error: boolean) => {
        completedRequests++;

        if (!error && res.success) {
          successfullyDeletedIds.push(element.id);
        } else if (error) {
          alert('Server Error: ' + error);
        }

        if (completedRequests === data.length) {
          if (callback) callback(successfullyDeletedIds);
        }
      });
    });
  }

  getAttributeByIds(fieldId: number) {
    return this.usecaseAttributes.find(
      (attr: any) =>
        attr.id === fieldId &&
        attr['system'] != 1 &&
        attr['type'] !== 'file' &&
        attr['listView'] != 1,
    );
  }

  // Reomove tooltip

  routeSubscription: any;
  removeIt(): void {
    this.routeSubscription = this.route.params.subscribe(() => {
      this.updateTooltipVisibility();
    });
    this.updateTooltipVisibility();
    console.log(this.routeSubscription);
  }

  private updateTooltipVisibility(): void {
    const currentUrl = this.route.snapshot.url.join('/');
    console.log('curnt', currentUrl);
    if (currentUrl.startsWith('uiforminfo')) {
      this.removeTooltip();
    }
  }

  private removeTooltip(): void {
    const tooltipElement = document.body.querySelector('.tooltip');
    console.log(tooltipElement, 'tool');
    if (tooltipElement) {
      console.log('isis ');
      document.body.removeChild(tooltipElement);
    }
  }

  ngOnDestroy(): void {
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  getTypeBadgeClass(type: string): string {
    const map: Record<string, string> = {
      idate: 'bg-primary-subtle text-primary', // blue-purple feel
      date: 'bg-info-subtle text-info', // light blue
      itime: 'bg-success-subtle text-success', // teal/green
      time: 'bg-success-subtle text-success', // teal/green
      dateandtime: 'bg-warning-subtle text-muted', // amber
      text: 'bg-secondary-subtle text-secondary', // gray
      long: 'bg-danger-subtle text-danger', // red-orange
    };
    return map[type] ?? 'bg-light text-muted';
  }
}
